module.exports = __webpack_public_path__ + "media/images/icons/expand-6f75315b46cedd1926a239f6023751d4.svg";